import { render } from "./[tab].vue?vue&type=template&id=028218be"
import script from "./[tab].vue?vue&type=script&lang=js"
export * from "./[tab].vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__